import Button from '@mui/material/Button';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Container from '/@/components/container';
import ShareButtons from '/@/components/share-buttons';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import { getShareAppName, withOverrideTheme } from '/@/utils/theme-override';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@connect((state) => ({
    sessionCountry: getSessionCountry(state),
}))
@autobind
export default class CatalogHeader extends Component {
    static propTypes = {
        brand: PropTypes.object,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        onGoBack: PropTypes.func,
        zone: PropTypes.string,
        showGoBack: PropTypes.bool,
    };

    static defaultProps = {
        showGoBack: true,
    };

    render() {
        const { brand, title, zone, subtitle, description, biotechnology } = this.props;
        const brandStyles = brand ? styles[`theme-${brand.theme}-${brand.type}`] : styles['theme-none'];

        return (
            <div className={styles.root}>
                <div className={classNames(styles.cover, brandStyles)}>
                    <div className={classNames(styles.layer)} />
                    <div className={styles.head}>
                        <div className={styles.container}>
                            {brand && <div className={classNames(styles.logo, styles[brand.logoCodename])} />}
                        </div>
                    </div>
                </div>
                {this.props.onGoBack && this.props.showGoBack && (
                    <Container classNameRoot={classNames(styles.rootContainer)} className={styles.wrapperContainer}>
                        <div className={styles.goBack}>
                            <Button variant='text' onClick={this.props.onGoBack}>
                                {_('Volver')}
                            </Button>
                        </div>
                    </Container>
                )}
                {(title || zone || subtitle || description) && (
                    <div
                        className={classNames(
                            styles.body,
                            biotechnology ? styles.biotechnology : '',
                            this.props.onGoBack && this.props.showGoBack ? '' : styles.noGoBack
                        )}
                    >
                        <div className={styles.head}>
                            <div className={styles.titleAndZone}>
                                {title && (
                                    <Title theme={settings.app.theme} size='xl' bolder>
                                        {_(title)}
                                    </Title>
                                )}
                                {zone && (
                                    <Title className={styles.zone} theme={settings.app.theme} size='lg' bolder>
                                        {_(zone)}
                                    </Title>
                                )}
                            </div>
                            {subtitle && (
                                <Title theme={settings.app.theme} size='lg' bolder>
                                    {_(subtitle)}
                                </Title>
                            )}
                            {description && (
                                <Title theme={settings.app.theme} size='md' bolder>
                                    {_(description)}
                                </Title>
                            )}
                        </div>
                        <ShareButtons
                            className={styles.share}
                            message={`${_('Te comparto un catalogo de {{appName}}!', {
                                appName: getShareAppName(settings.app.name),
                            })} \n ${withOverrideTheme(`${window.location}?country=${this.props.sessionCountry.code}`)}`}
                            handleCopy={() => {
                                navigator.clipboard.writeText(
                                    withOverrideTheme(`${window.location}?country=${this.props.sessionCountry.code}`)
                                );
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}
